export default __webpack_public_path__ + "static/media/area1_2880.9b0fa3c2.webp";